"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HexColorInput = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var TabStyles_1 = require("../../styles/TabStyles");
var Declarative_1 = require("../../utils/Declarative");
var TextFieldWidget_1 = require("../TextField/TextFieldWidget");
var ColorGridWidget_1 = require("./ColorGridWidget");
var _a = TabStyles_1.TabStyles.Sizing, RowHeight = _a.RowHeight, BorderWidth = _a.BorderWidth;
var RootStyleName = TypeStyle.style({
    alignItems: 'flex-end',
    display: 'flex',
    paddingTop: TabStyles_1.TabStyles.Spacing.SmallSpace,
});
var PreviewSwatchStyleName = TypeStyle.style({
    borderColor: TabStyles_1.TabStyles.Colors.L6,
    borderStyle: 'solid',
    borderWidth: BorderWidth,
    boxSizing: 'border-box',
    height: RowHeight,
    marginRight: 12,
    width: RowHeight,
});
var TextFieldStyleName = TypeStyle.style({ flexGrow: 1, flexBasis: '50px' });
var InputStyle = { width: '100%' };
function isValidHexColor(color) {
    return /^#?[0-9A-Fa-f]{6}$/.test(color);
}
function formatColor(color) {
    var formattedColor = (color || '').toUpperCase();
    if (formattedColor.charAt(0) !== '#') {
        formattedColor = '#' + formattedColor;
    }
    return formattedColor;
}
var HexColorInput = /** @class */ (function (_super) {
    tslib_1.__extends(HexColorInput, _super);
    function HexColorInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hexColorText: _this.props.color || '',
        };
        _this.isValid = function () {
            if (!_this.state.hexColorText || _this.state.hexColorText === '#' || isValidHexColor(_this.state.hexColorText)) {
                return undefined;
            }
            return false;
        };
        _this.handleChange = function (e) {
            var value = e.target.value;
            if (!/^#?[0-9A-Fa-f]{0,6}$/.test(value)) {
                return;
            }
            _this.setState({ hexColorText: e.target.value });
        };
        _this.handleKeyDown = function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
                if (!e.repeat && isValidHexColor(_this.state.hexColorText)) {
                    _this.props.onConfirm(formatColor(_this.state.hexColorText));
                }
            }
        };
        _this.handleSwatchClicked = function (color) {
            if (isValidHexColor(_this.state.hexColorText)) {
                _this.props.onConfirm(formatColor(color.toLowerCase()));
            }
        };
        return _this;
    }
    HexColorInput.prototype.render = function () {
        return (React.createElement("div", { className: RootStyleName, "data-tb-test-id": Declarative_1.makeTestId(this.props.testId, 'HexInput') },
            React.createElement("div", { className: PreviewSwatchStyleName },
                React.createElement(ColorGridWidget_1.ColorSwatchWidget, { color: this.getCustomColor() || 'transparent', disabled: !this.getCustomColor(), onClick: this.handleSwatchClicked, selected: this.shouldSwatchBeSelected(), size: RowHeight - 2 * BorderWidth, testId: this.props.testId })),
            React.createElement(TextFieldWidget_1.TextFieldWidget, { className: TextFieldStyleName, label: this.props.label, maxLength: 7, onChange: this.handleChange, 
                /* onClear is omitted because the TextField from Tableau UI calls stopPropagation on ESC events when there is text present --
                * which is always the case for this control, as it always displays the '#' prefix. Removing this stopPropagation would be
                * technically-correct but would break dialogs/overlays, etc. Easiest way to work around is just not to show the clear button. */
                onKeyDown: this.handleKeyDown, placeholder: '#', ref: this.props.inputRef, 
                // TFSID 1165428: Default is 20, which causes the input to grow too wide.
                size: 10, spellCheck: false, style: InputStyle, testId: this.props.testId, valid: this.isValid(), value: formatColor(this.state.hexColorText) })));
    };
    HexColorInput.prototype.getCustomColor = function () {
        if (isValidHexColor(this.state.hexColorText)) {
            return formatColor(this.state.hexColorText);
        }
        return null;
    };
    HexColorInput.prototype.shouldSwatchBeSelected = function () {
        return isValidHexColor(this.props.color) && formatColor(this.state.hexColorText) === formatColor(this.props.color);
    };
    return HexColorInput;
}(React.Component));
exports.HexColorInput = HexColorInput;
//# sourceMappingURL=HexColorInputWidget.js.map